import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import clsx from 'clsx';
import { useFormContext } from 'react-hook-form';
import { capitalize } from '@modernhealth/capitalize';
import { useFormInputLayout, FormInputLayout, } from '../FormInputLayout/FormInputLayout';
import { Icon } from '../../Icon/Icon';
import * as styles from './FormInputText.module.scss';
const Name = 'FormInputText';
/**
 * FormInputText provides user input for text, and all data types which do not have a dedicted input component.
 */
export const FormInputText = props => {
    const { register } = useFormContext();
    const { className, disabled, hint, id, label, labelledBy, name, dependentFields, required, componentProps: { icon, iconAlign, max, min, trim, type, ...otherComponentProps }, } = useFormInputLayout(props);
    const fieldStyles = clsx(useFormInputStyles({ iconAlign }));
    if (!id)
        return null;
    const registered = register(name, {
        disabled,
        max,
        min,
        valueAsNumber: type === 'number',
        valueAsDate: type === 'date',
        setValueAs: trim ? value => `${value}`.trim() : undefined,
        deps: dependentFields,
    });
    const hasStartIcon = Boolean(icon) && iconAlign === 'start';
    const hasEndIcon = Boolean(icon) && iconAlign === 'end';
    return (_jsx(FormInputLayout, { className: className, "data-component": Name, disabled: disabled, fieldId: id, hint: hint, label: label, labelledBy: labelledBy, name: name, required: required, renderInput: state => {
            const { disabled, hintId, inputId, isValid, labelId, required } = state;
            return (_jsxs("div", { className: fieldStyles, "data-invalid": !isValid, "data-disabled": disabled, children: [hasStartIcon && _jsx(Icon, { name: icon, size: 20, "aria-hidden": true }), _jsx("input", { "aria-describedby": hintId, "aria-invalid": !isValid, "aria-labelledby": labelId, "aria-required": required, id: inputId, type: type, ...registered, ...otherComponentProps }), hasEndIcon && _jsx(Icon, { name: icon, size: 20, "aria-hidden": true })] }));
        } }));
};
export function useFormInputStyles(props) {
    const { iconAlign, className } = props ?? {};
    return clsx(styles.container, iconAlign && styles[`iconAlign${capitalize(iconAlign)}`], className);
}
